import {Button, Select, Space} from "antd";
import {DownOutlined, UpOutlined} from "@ant-design/icons";
import {useEffect, useState} from "react";

export default function ResultListBox({list, onChange, defaultValue, text, value, labelPositionTop, width, suffixIcon, otherData, selectProps = {}}) {
    const [selected, setSelected] = useState(value || defaultValue)
    const [items, setItems] = useState([])

    const onPrev = () => {
        const index = items?.findIndex(x => x === selected)
        if(index > 0) {
            setSelected(items[index-1])
        }
    }
    const onNext = () => {
        const index = items?.findIndex(x => x === selected)
        if(index < items?.length-1) {
            setSelected(items[index+1])
        }
    }

    const renderList = () => {
        return Array.from(new Set(items)).map(x => {
            return (
                <Select.Option value={x}>
                    {x}
                </Select.Option>
            )
        })
    }

    useEffect(() => {
        if(selected && selected !== value) {
            onChange && onChange(selected)
        }
    }, [selected]);

    useEffect(() => {
        if(value !== selected)
            setSelected(value)
    }, [value])

    useEffect(() => {
        setItems(Array.from(new Set(list)))
    }, [list])

    return (
        <div style={{display: 'flex', alignItems: labelPositionTop ? 'start' : 'center', flexDirection: labelPositionTop ? 'column' : 'row'}}>
            <label>
                {text}
            </label>
            <Space size={0}>
                <Select
                    suffixIcon={suffixIcon}
                    style={{width: width || 200}}
                    value={selected}
                    onChange={(val) => {setSelected(val)}}
                    size={'small'}
                    {...selectProps}
                >
                    {renderList()}
                </Select>
                <Button disabled={items?.findIndex(x => x === selected) === 0} onClick={onPrev} size={'small'} icon={<UpOutlined />} />
                <Button disabled={items?.findIndex(x => x === selected) === items?.length-1} onClick={onNext} size={'small'} icon={<DownOutlined />} />
            </Space>
        </div>
    )
}